import './TranscriptsByStudentInstructionsPage.css';

const TranscriptsByStudentInstructionsPage = () => (
  <div className="instructions-page page">
    <div className="instructions-header">
      <h2 className="instructions-title">Instructions: Reviewing student transcripts</h2>
    </div>
    <ul className="instructions-list">
      <li>Individually, or with a partner, review student transcripts assigned to you.</li>
      <li>
        Determine whether the student took a set of courses that meet college eligibility requirements. Refer to the
        handout that lists your state university course recommendations. Indicate the student's "college eligibility"
        status: No/Yes/Yes+
      </li>
      <li>
        Determine whether the student reflects any of the "Typical Student Profiles," identified on p. 11 of your
        workbook. Indicate which profiles fit the student's experience.
      </li>
      <li>Add any interesting notes about the student you want to capture and share.</li>
      <li>Be prepared to share your observations and key takeaways with your school Team.</li>
    </ul>
    <p className="instructions-note">
      <em>
        Note: While transcripts reflect courses taken in high school, certain courses (e.g., Algebra I, Physical Science
        Honors) taken in middle school count toward college eligibility. These don't appear on the transcripts, but the
        EOAA accounts for these courses.
      </em>
    </p>
  </div>
);

export default TranscriptsByStudentInstructionsPage;
